/* eslint-disable react/prop-types */
import React, { useContext, useEffect, useState } from 'react';
import { MapContainer, TileLayer, Polygon } from 'react-leaflet';
import AppContext from 'context/Context';
import 'leaflet.tilelayer.colorfilter';
import 'leaflet/dist/leaflet.css';
import '@changey/react-leaflet-markercluster/dist/styles.min.css';
import { isEmpty } from 'lodash';
import Legend from 'components/common/map/Legend';
import { getColorScale } from 'helpers/leaflet-utils';
import GeotiffLayerSideBySide from './GeoTiffLayerSidebySide';

const LeafletMapSideBySide = ({ data, leftSide, rightSide, ...rest }) => {
  const {
    config: { isRTL }
  } = useContext(AppContext);

  const { coordinates, mapData } = data;
  const [indexScale, setIndexScale] = useState([]);
  const [layerVisible, setLayerVisible] = useState(true);

  useEffect(() => {
    setIndexScale(getColorScale(mapData[0].title));
  }, [data]);

  const position = coordinates[0];
  const fillColor = {
    color: 'white',
    fillColor: '#fff',
    opacity: 1,
    fillOpacity: 0
  };
  const leftSideTiffUrl = mapData.find(item => item.key === leftSide).tifUrl;
  const rightSideTiffUrl = mapData.find(item => item.key === rightSide).tifUrl;

  const leftYear = mapData
    .find(item => item.key === leftSide)
    .title.match(/\d{4}/)[0];
  const rightYear = mapData
    .find(item => item.key === rightSide)
    .title.match(/\d{4}/)[0];

  const fullTitle = mapData[0]?.title;
  const legendTitleMap = fullTitle.replace(/\s\d{4}$/, '');

  if (isEmpty(leftSideTiffUrl) || isEmpty(rightSideTiffUrl)) {
    return null;
  }
  return (
    <MapContainer
      zoom={isRTL ? 1.8 : 1.5}
      minZoom={isRTL ? 1.8 : 1.3}
      zoomSnap={0.5}
      center={position}
      {...rest}
      radius={200}
    >
      <TileLayer
        attribution='Google Maps &copy; <a href="https://farmsio.com">Farmsio</a>'
        url="https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}"
        subdomains={['mt0', 'mt1', 'mt2', 'mt3']}
      />
      {!isEmpty(data.coordinates) && (
        <Polygon pathOptions={fillColor} positions={data.coordinates} />
      )}
      {!isEmpty(leftSideTiffUrl && rightSideTiffUrl && indexScale) && (
        <GeotiffLayerSideBySide
          leftUrl={leftSideTiffUrl}
          rightUrl={rightSideTiffUrl}
          title={mapData[0].title}
          coordinates={coordinates}
          indexScale={indexScale}
          varients={[leftYear, rightYear]}
          layerVisible={layerVisible}
        />
      )}
      {!isEmpty(indexScale) && (
        <Legend
          indexScale={indexScale}
          title={legendTitleMap}
          setLayerVisible={setLayerVisible}
        />
      )}
    </MapContainer>
  );
};

export default LeafletMapSideBySide;
